import { createRandomId } from "./utils.mjs";
export const createActionMethods = (addAndProcessCommand) => {
    return {
        addCustomStickerLineItem(customStickerId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addCustomStickerLineItem',
                customStickerId,
                quantity,
            });
        },
        addStickerShopLineItem(stickerShopItemId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addStickerShopLineItem',
                stickerShopItemId,
                quantity,
            });
        },
        addStickerPackLineItem(stickerPackId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addStickerPackLineItem',
                stickerPackId,
                quantity,
            });
        },
        addGiftCardLineItem(amount, name, imageUrl, quantity = 1) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addGiftCardLineItem',
                name,
                amount,
                imageUrl,
                quantity,
            });
        },
        removeLineItem(lineItemId) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'removeLineItem',
                lineItemId,
            });
        },
        updateLineItem(lineItemId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'updateLineItem',
                lineItemId,
                quantity,
            });
        },
        duplicateCustomStickerLineItem(lineItemId, quantity) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'duplicateCustomStickerLineItem',
                lineItemId,
                quantity,
            });
        },
        /**
         * Also known as "reorder"
         */
        addLinesFromOrder(orderId, sheetIds, email) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addLinesFromOrder',
                orderId,
                sheetIds,
                email,
            });
        },
        selectShippingMethod(shippingMethodId, shippingMethodType, shippingMethodPrice) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'selectShippingMethod',
                shippingMethodId,
                shippingMethodType,
                shippingMethodPrice,
            });
        },
        setBillingAddress(address) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setBillingAddress',
                address,
            });
        },
        setUseBillingAddress(useBillingAddress) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setUseBillingAddress',
                useBillingAddress,
            });
        },
        selectPaymentMethod(paymentMethodId) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'selectPaymentMethod',
                paymentMethodId,
            });
        },
        addCode(discountOrGiftCardCode) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'addCode',
                code: discountOrGiftCardCode,
            });
        },
        removeCode(discountOrGiftCardCode) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'removeCode',
                code: discountOrGiftCardCode,
            });
        },
        setAddress(address) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setAddress',
                address,
            });
        },
        setEmail(email) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setEmail',
                email,
            });
        },
        setPhoneNumber(phoneNumber) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setPhoneNumber',
                phoneNumber,
            });
        },
        setCompanyName(companyName) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setCompanyName',
                companyName,
            });
        },
        setIsCompany(isCompany) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setIsCompany',
                isCompany,
            });
        },
        setVatNumber(vatNumber) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setVatNumber',
                vatNumber,
            });
        },
        setReference(reference) {
            return addAndProcessCommand({
                id: createRandomId(),
                command: 'setReference',
                reference,
            });
        },
    };
};
//# sourceMappingURL=actionMethods.js.map